import React, { useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import useChatNavigation from "../../../../../Common/useChatNavigation";
import { getMineActiveBXPList } from "../../../../../../redux/ots/action";
import LoadCSSforfirstTime from "../../../../../../CloudStorage/LoadCSSforfirstTime";
import GetRemainDays from "../../PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../../PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import { decodeHtml } from "../../../../../../assests/extention/commonfunction";
import { PAGE_SIZE } from "../../../../../../redux/constants";
import { getPostPaginationList } from "../../../../../../redux/project/action";
import OrderPostPagination from "../../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";

export default function MineCompletedBXPListing() {
  const path = "Assets/scss/myorders.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);


  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { letChat } = useChatNavigation();


  // const listdata?.response? = useSelector(({ ots: { mineactivebxplist } }) => mineactivebxplist);

  useEffect(() => {
    dispatch(getMineActiveBXPList(3, 1));
  }, []);


  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    const data = {
      index: pageNumber,
      size: PAGE_SIZE,
      status: 3,
      is_bxp: 1,
      is_mine: 1
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }
  }, [pageNumber]);



  return (
    <>
      <div className ="order-tabs">
        <OrderPostPagination
          totalitemcounts={listdata?.count}
          size={PAGE_SIZE}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
        <div className ="tab-content">
          <div className ="posted-project">
            <div className ="recent-post">
              {/* <h4>One Time Services (OTS) ({listdata?.response??.length || 0})</h4> */}
              {
                Array.isArray(listdata?.response) && listdata?.response?.length > 0 ?
                  <>
                    {listdata?.response?.map((item, index) => (
                      <div key={index} className ="post-back">
                        <div className ="col-md-5">
                          <h3>{decodeHtml(item.title)}</h3>
                          <div className ="post-img">
                            <p className ="deadline-p">Completed</p>
                          </div>
                        </div>
                        <div className ="activity col-md-4">
                          <h6>Active milestone: {item?.active_milestone_count}</h6>
                          <h5>
                            {!item?.active_milestone?.title
                              ? "No Active Milestone"
                              : decodeHtml(item?.active_milestone?.title)}
                          </h5>

                          <GetStatus status={item?.active_milestone?.status} />
                        </div>
                        <button
                          onClick={() =>
                            navigate(
                              `/${lan}/dashboard/myorders/project/active/${item.id}`,
                            )
                          }
                          className ="btn"
                        >
                          Review works
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                            alt=""
                          />
                        </button>
                      </div>
                    ))
                    }
                  </>
                  :
                  <PostNotFound title={"No Post Found"} height={200} />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
